
import { createClient } from '@supabase/supabase-js';
import { supabase } from "@/integrations/supabase/client";

// Service role client for bypassing RLS when staff are authenticated via SMS/bypass
const getServiceRoleClient = () => {
  // For now using regular client - service role would be ideal but requires proper configuration
  console.log('🔧 Using regular client (service role configuration pending)');
  return supabase;
};

export const getSupabaseClient = () => {
  // Check authentication type with enhanced debugging
  const staffAuth = localStorage.getItem('staff_sms_auth');
  const bypass = localStorage.getItem('location_bypass');
  const smsAdminAuth = localStorage.getItem('sms_admin_auth');
  let isStaffAuthenticated = false;
  let authMethod = 'none';
  
  console.log('🔍 getSupabaseClient - Authentication Check:', {
    hasStaffAuth: !!staffAuth,
    hasBypass: !!bypass,
    hasSmsAdmin: !!smsAdminAuth,
    timestamp: new Date().toISOString()
  });
  
  // Check SMS staff authentication first
  if (staffAuth) {
    try {
      const authData = JSON.parse(staffAuth);
      console.log('📱 Staff SMS auth data:', {
        authenticated: authData.authenticated,
        expiry: new Date(authData.expiry).toISOString(),
        timeUntilExpiry: authData.expiry - new Date().getTime(),
        isValid: authData.authenticated && authData.expiry > new Date().getTime()
      });
      
      if (authData.authenticated && authData.expiry > new Date().getTime()) {
        isStaffAuthenticated = true;
        authMethod = 'sms_staff';
        console.log('✅ SMS staff authentication valid');
      } else {
        console.log('❌ SMS staff authentication expired or invalid');
      }
    } catch (e) {
      console.error('❌ Error parsing SMS staff auth:', e);
    }
  }
  
  // Check location bypass if staff auth not valid
  if (!isStaffAuthenticated && bypass) {
    try {
      const bypassData = JSON.parse(bypass);
      console.log('📍 Location bypass data:', {
        expiry: new Date(bypassData.expiry).toISOString(),
        timeUntilExpiry: bypassData.expiry - new Date().getTime(),
        isValid: bypassData.expiry > new Date().getTime()
      });
      
      if (bypassData.expiry > new Date().getTime()) {
        isStaffAuthenticated = true;
        authMethod = 'location_bypass';
        console.log('✅ Location bypass authentication valid');
      } else {
        console.log('❌ Location bypass authentication expired');
      }
    } catch (e) {
      console.error('❌ Error parsing location bypass:', e);
    }
  }
  
  // Check SMS admin authentication
  if (!isStaffAuthenticated && smsAdminAuth) {
    try {
      const adminData = JSON.parse(smsAdminAuth);
      console.log('👑 SMS admin auth data:', {
        authenticated: adminData.authenticated,
        expiry: new Date(adminData.expiry).toISOString(),
        timeUntilExpiry: adminData.expiry - new Date().getTime(),
        isValid: adminData.authenticated && adminData.expiry > new Date().getTime()
      });
      
      if (adminData.authenticated && adminData.expiry > new Date().getTime()) {
        isStaffAuthenticated = true;
        authMethod = 'sms_admin';
        console.log('✅ SMS admin authentication valid');
      } else {
        console.log('❌ SMS admin authentication expired or invalid');
      }
    } catch (e) {
      console.error('❌ Error parsing SMS admin auth:', e);
    }
  }
  
  console.log('🔐 Final authentication state:', {
    isStaffAuthenticated,
    authMethod,
    willUseRegularClient: true
  });
  
  if (isStaffAuthenticated) {
    console.log(`📊 Using Supabase client with ${authMethod} authentication support`);
  } else {
    console.log('📊 Using Supabase client for unauthenticated access (may be limited by RLS)');
  }
  
  return supabase;
};
